module.exports = __webpack_public_path__ + "static/media/theater-masks.d697ddfb.svg";